import { AsyncPipe, NgIf, NgTemplateOutlet } from "@angular/common";
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AppQuery } from "../../../../store/app.query";
import { UserMenuModule } from "../user-menu/user-menu.module";

@Component({
    selector: "nerri-citizen-navbar",
    templateUrl: "./citizen-navbar.template.html",
    styleUrls: ["./citizen-navbar.style.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [
        AsyncPipe,
        MatButtonModule,
        MatIconModule,
        NgIf,
        NgTemplateOutlet,
        RouterLink,
        RouterLinkActive,
        TranslateModule,
        UserMenuModule
    ]
})
export class CitizenNavbarComponent implements OnChanges {
    @Input({ required: true })
    public isSmallScreen!: boolean;

    public organisation$ = this.appQuery.organisation$;

    public navOpen = false;

    constructor(private appQuery: AppQuery) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if ("isSmallScreen" in changes) {
            if (!this.isSmallScreen) {
                this.navOpen = false;
            }
        }
    }
}
